import React, { useState } from "react"
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
import { useTranslation } from "react-i18next"
import { formatCurrencyAmount } from "utils/currency"

const SettlementModal = ({ isOpen, toggle, pendingAmount = 0, onConfirm }) => {
  const { t } = useTranslation()
  const [amount, setAmount] = useState("")
  const [settlementDate, setSettlementDate] = useState(
    new Date().toISOString().split("T")[0]
  )

  const handleConfirm = () => {
    onConfirm(Number(amount), settlementDate)
    setAmount("")
    setSettlementDate(new Date().toISOString().split("T")[0])
  }

  const handleClose = () => {
    setAmount("")
    setSettlementDate(new Date().toISOString().split("T")[0])
    toggle()
  }

  const isValid =
    amount !== "" &&
    Number(amount) > 0 &&
    Number(amount) <= pendingAmount &&
    settlementDate !== ""

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose}>{t("COD Settlement")}</ModalHeader>
      <ModalBody>
        <div className="alert alert-primary mb-3">
          <strong>{t("Pending Amount:")}</strong> {formatCurrencyAmount(pendingAmount)}
        </div>

        <FormGroup>
          <Label>
            {t("Settlement Amount")} <span className="text-danger">*</span>
          </Label>
          <Input
            type="number"
            min={1}
            max={pendingAmount}
            value={amount}
            onChange={e => setAmount(e.target.value)}
            placeholder={t("Max SAR {{amount}}", { amount: pendingAmount })}
          />
        </FormGroup>

        <FormGroup>
          <Label>
            {t("Settlement Date")} <span className="text-danger">*</span>
          </Label>
          <Input
            type="date"
            value={settlementDate}
            max={new Date().toISOString().split("T")[0]}
            onChange={e => setSettlementDate(e.target.value)}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleConfirm} disabled={!isValid}>
          {t("Confirm Settlement")}
        </Button>
        <Button color="light" onClick={handleClose}>
          {t("Cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default SettlementModal
